module.exports = __webpack_public_path__ + "static/media/cancel.9e4d7c0a.svg";